import { memo } from "react";

import Threads from "../../../../../public/assets/icon/sns/threads.svg?react";
import { IconCreator } from "../_utils/icon-creator";

import type { SVGIconProps } from "../_utils/icon-creator";

const ThreadsIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Threads });
	return <Icon />;
};

export default memo(ThreadsIcon);
